module.exports = __webpack_public_path__ + "img/background.69be3411.png";